// src/components/admin/Tally/index.js

import React, { useState } from 'react';
import TallyDashboard from './TallyDashboard';
import AddExpense from './AddExpense';
import ExpenseList from './ExpenseList';
import IncomeManager from './IncomeManager';
import ClassFeeSummary from './ClassFeeSummary';
import { useTranslation } from "react-i18next";

const Tally = ({ schoolId, academicYearId, token, onToast, academicYear }) => {
  const { t } = useTranslation(); 
  const [activeTab, setActiveTab] = useState('dashboard');
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleExpenseAdded = () => {
    setRefreshTrigger(prev => prev + 1);
    setActiveTab('expenses');
  };

  const handleIncomeAdded = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="tally-module">
      <div className="tally-tabs">
        <button 
          className={`tally-tab ${activeTab === 'dashboard' ? 'active' : ''}`}
          onClick={() => setActiveTab('dashboard')}
        >
          📊 {t('dashboard')}
        </button>
        <button 
          className={`tally-tab ${activeTab === 'add' ? 'active' : ''}`}
          onClick={() => setActiveTab('add')}
        >
          ➕ {t('addExpense')}
        </button>
        <button 
          className={`tally-tab ${activeTab === 'expenses' ? 'active' : ''}`}
          onClick={() => setActiveTab('expenses')}
        >
          📋 {t('viewExpenses')}
        </button>
        <button
          className={`tally-tab ${activeTab === 'income' ? 'active' : ''}`}
          onClick={() => setActiveTab('income')}
        >
          {t('tallyIncome')}
        </button>
        <button
          className={`tally-tab ${activeTab === 'class-fees' ? 'active' : ''}`}
          onClick={() => setActiveTab('class-fees')}
        >
          {t('classFeeSummary')}
        </button>
      </div>

      <div className="tally-content">
        {activeTab === 'dashboard' && (
          <TallyDashboard
            schoolId={schoolId}
            academicYearId={academicYearId}
            token={token}
            onToast={onToast}
            academicYear={academicYear}
          />
        )}

        {activeTab === 'add' && (
          <AddExpense
            schoolId={schoolId}
            academicYearId={academicYearId}
            token={token}
            onExpenseAdded={handleExpenseAdded}
            onToast={onToast}
          />
        )}

        {activeTab === 'expenses' && (
          <ExpenseList
            schoolId={schoolId}
            academicYearId={academicYearId}
            token={token}
            onToast={onToast}
            refreshTrigger={refreshTrigger}
          />
        )}

        {activeTab === 'income' && (
          <IncomeManager
            schoolId={schoolId}
            academicYearId={academicYearId}
            onToast={onToast}
            onIncomeAdded={handleIncomeAdded}
          />
        )}

        {activeTab === 'class-fees' && (
          <ClassFeeSummary
            schoolId={schoolId}
            academicYearId={academicYearId}
            onToast={onToast}
          />
        )}
      </div>
    </div>
  );
};

export default Tally;